<div class="row printArea">
    <div>
        <div>
            <h1 class="fw-bold fs-4 mb-3">
                {{'call_report'|translate}}
                {{shareObject.phone?.number}}
            </h1>
            <h1 class="fw-bold fs-5 mb-3">
                {{shareObject.phone?.holder?.profile?.name}} - {{shareObject.phone?.holder?.profile?.employeeGroup.name}}
            </h1>
        </div>
        <div *ngIf="shareObject.filterForm.value.startDate != shareObject.filterForm.value.endDate">
            {{'from_date'|translate}}: {{shareObject.filterForm.value.startDate | date: 'dd/MM/yyyy'}} -
            {{'to_date'|translate}}: {{shareObject.filterForm.value.endDate | date: 'dd/MM/yyyy'}}
        </div>
        <div *ngIf="shareObject.filterForm.value.startDate == shareObject.filterForm.value.endDate">
            {{'report_date'|translate}}: {{shareObject.filterForm.value.startDate | date: 'dd/MM/yyyy'}}
        </div>
        <div class="dont-print mb-3 mt-3">
            <!-- btn search click to show Modal -->
            <button class="btn btn-sm btn-primary me-2" data-bs-toggle="modal" data-bs-target="#modal">
                <i class="fa-solid fa-magnifying-glass"></i>
                {{'btn_change'|translate}}
            </button>
            <!-- Print -->
            <button class="btn btn-sm btn-success me-2" (click)="print()">
                <i class="fa-solid fa-print"></i>
                {{'btn_print'|translate}}
            </button>
        </div>

    </div>
    <div class="col-md-12">
        <h5>{{'call_report_by_time'|translate}}</h5>
        <canvas id="lineChart"></canvas>
    </div>
    <div class="col-md-8">
        <h5>{{'call_report_by_call_type'|translate}}</h5>
        <canvas id="pieChart"></canvas>
    </div>
</div>

<!-- modal -->
<div class="modal fade" id="modal" tabindex="-1" aria-labelledby="filterModal" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="filterModal">{{'call_report_detail'|translate}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="row">

                    <form action="" [formGroup]="shareObject.filterForm" class="" (ngSubmit)="getData()">
                        <div class="mb-3">
                            <label class="form-label fw-bold" for="date">{{'filter_start_date'|translate}}</label>
                            <input type="date" class="form-control form-control-sm" formControlName="startDate"
                                id="startDate">
                        </div>
                        <div class="mb-3">
                            <label class="form-label fw-bold" for="date">{{'filter_end_date'|translate}}</label>
                            <input type="date" class="form-control form-control-sm" formControlName="endDate"
                                id="endDate">
                        </div>
                        <button class="btn btn-sm btn-primary">
                            <i class="fa-solid fa-magnifying-glass"></i>
                            {{'filter'|translate}}
                        </button>
                    </form>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary"
                    data-bs-dismiss="modal">{{'btn_close'|translate}}</button>
            </div>
        </div>

    </div>
</div>